export const apiDomain = 
    process.env.NODE_ENV === 'production' ? '//lcode.m-texte.de' : 'http://localhost:8080';